"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateNavigationChange = void 0;
var state_1 = require("../state");
var fieldHandler_1 = require("./fieldHandler");
var wizardPresentation_1 = require("./wizardPresentation");
// TODO: Refactor this file ()`navigation.ts`) and `controlButtons.ts`. 
// Make Navigation component/module.
/*
 * Validate for a few key things
 * 1. That when moving forward we aren't trying to skip a step
 * 2. If we are trying to visit a step we have visited before.
 *    This might be the case if we jump backwards to change something. Then skip forward.
 * 3. That all required fields have been filled out in the current pane.
 */
var validateNavigationChange = function (newStep) {
    var direction = state_1.state.activeStep > newStep ? 'PREV' : 'NEXT';
    // Moving forward is fine if step 2 is filled out
    // ...or if we are moving backwards
    if (direction === 'PREV' || state_1.state.zipCode) {
        return true;
    }
    // Validate we aren't trying to jump too far foward.
    // if (newStep !== state.activeStep + 1) {
    //   return false;
    // }
    if (state_1.state.activeStep === 1 && newStep > 2) {
        return false;
    }
    // If this is the second step with the zip codes, then we need to
    // ...validate all fields are filled out. (For panes with fields).
    if (state_1.state.activeStep === 2 && !fieldHandler_1.validateFields()) {
        wizardPresentation_1.wizardWrapElement.classList.add('has-error');
        setTimeout(function () { return wizardPresentation_1.wizardWrapElement.classList.remove('has-error'); }, 500);
        return false;
    }
    return true;
};
exports.validateNavigationChange = validateNavigationChange;
exports.default = (function (navButtons) {
    var setBtnAsVisited = function (btn) {
        btn.classList.remove('is-active');
        btn.classList.add('is-visited');
        btn.classList.remove('is-prior');
    };
    var setBtnAsUnVisited = function (btn) {
        btn.classList.remove('is-active');
        btn.classList.remove('is-visited');
        btn.classList.remove('is-prior');
    };
    var setBtnAsPriorVisited = function (btn) {
        btn.classList.remove('is-active');
        btn.classList.remove('is-visited');
        btn.classList.add('is-prior');
    };
    var setBtnAsActive = function (btn) {
        btn.classList.add('is-active');
        btn.classList.remove('is-visited');
        btn.classList.remove('is-prior');
    };
    var navButtonClickEvent = function (e) {
        var btn = e.target;
        var newActiveStepDataset = btn.dataset.advisorNavStep;
        if (!newActiveStepDataset) {
            return;
        }
        var proposedNewStep = +newActiveStepDataset;
        var isValid = exports.validateNavigationChange(proposedNewStep);
        if (!isValid) {
            return false;
        }
        state_1.setState({ activeStep: proposedNewStep });
        if (proposedNewStep > state_1.state.furthestVisitedStep) {
            state_1.setState({ furthestVisitedStep: proposedNewStep });
        }
        return;
    };
    var updateNavButtons = function (state, update) {
        var newStep = update.activeStep;
        if (update.activeStep > state.totalSteps) {
            return;
        }
        var activeNavItem = document.querySelector('[data-advisor-nav-step="' + newStep + '"]');
        if (!activeNavItem) {
            console.error('Cannot locate selected nav item');
            return;
        }
        var navBtnIndex = navButtons.indexOf(activeNavItem);
        var visitedItems = navButtons.slice(0, navBtnIndex);
        var priorVisitedItems = navButtons.slice(navBtnIndex, state.furthestVisitedStep);
        var unVisitedItems = navButtons.slice(state.furthestVisitedStep, navButtons.length);
        visitedItems.map(setBtnAsVisited);
        unVisitedItems.map(setBtnAsUnVisited);
        priorVisitedItems.map(setBtnAsPriorVisited);
        setBtnAsActive(activeNavItem);
        return;
    };
    state_1.subscribe('activeStep', updateNavButtons);
    navButtons.forEach(function (button) { return button.addEventListener('click', navButtonClickEvent); });
    setBtnAsActive(navButtons[0]);
});
